<template>
  <item-base
    :route-name="routeName"
    icon="house-fill"
  >
    サイト設定
  </item-base>
</template>

<script>
import ItemBase from './Base'

export default {
  components: {
    ItemBase
  },

  data () {
    return {
      routeName: 'site-config'
    }
  }
}
</script>
